(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hover-banner-section"] && !Shopify.designMode) return;
  try {
    
if (!window.__hbannerInit) {
  window.__hbannerInit = true;

  function activateHbanner(wrap, index) {
    var layers = wrap.querySelectorAll('.hbanner__layer');
    var texts = wrap.querySelectorAll('.hbanner__text');
    var dots = wrap.querySelectorAll('.hbanner__dot');

    layers.forEach(function (el, i) {
      var active = i === index;
      el.classList.toggle('is-active', active);
      var videos = el.querySelectorAll('video');
      videos.forEach(function (v) {
        if (active) {
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    });
    texts.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
    dots.forEach(function (el, i) { el.classList.toggle('is-active', i === index); });
  }

  document.addEventListener('mouseenter', function (e) {
    var zone = e.target.closest && e.target.closest('.hbanner__zone');
    if (!zone) return;
    var wrap = zone.closest('[data-hbanner]');
    if (!wrap) return;
    activateHbanner(wrap, parseInt(zone.dataset.index, 10));
  }, true);
}

  } catch(e) { console.error(e); }
})();
})();
